var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInformationCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM11 11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V12.9609C13.0001 12.7611 13.0001 12.523 12.9727 12.3184C12.9394 12.0713 12.8505 11.7294 12.5605 11.4395C12.2706 11.1495 11.9287 11.0606 11.6816 11.0273C11.477 10.9999 11.2389 10.9999 11.0391 11C11.0259 11 11.0128 11 11 11ZM11.9951 7C11.4455 7.00018 11 7.44782 11 8C11 8.55218 11.4455 8.99982 11.9951 9H12.0039C12.5537 9 13 8.55228 13 8C13 7.44772 12.5537 7 12.0039 7H11.9951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformationCircle);
export default __webpack_public_path__ + "static/media/icon-information-circle.11ca8c4a9b27fcba88716df24685541c.svg";
export { ForwardRef as ReactComponent };